// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"6e0967cb","209":"b93497f2","309":"63e7632b","343":"db7c823a","345":"d94f86e4","380":"363f1480","506":"6715d2fb","643":"7436d84c","645":"e3ba3ace","662":"380a4571","665":"99501861","723":"aa3f7868","789":"9d0046fe","812":"d28ce2cf"}[chunkId] + ".chunk.js";
};